export default __webpack_public_path__ + "media/images/banner/banner-26-925c10240040660fdf674290211daf2c.jpg";